import styled from '@emotion/styled';
import {
	CREATE_TEMPLATE_FOOTER_HEIGHT,
	CREATE_TEMPLATE_HEADER_HEIGHT,
} from '../../common/componentUtils';

export const StyledPrepareDocumentContainer = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
	box-sizing: border-box;
	overflow: hidden;
`;
export const StyledDocumentViewer = styled.div`
	height: calc(
		100vh - (${CREATE_TEMPLATE_HEADER_HEIGHT} + ${CREATE_TEMPLATE_FOOTER_HEIGHT})
	); // 100% - fixed header height in px
	width: 60%;
	box-sizing: border-box;
	overflow: scroll;
	display: flex;
	flex-grow: 1;
	justify-content: space-evenly;
	background-color: #d9d9d9;
	overflow: hidden;
	// padding: 40px 40px 0;
`;
